// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"24":"0b9e13e1","262":"def25bd4"}[chunkId] + ".css";
};